import { Component, Input } from "@angular/core";
import { HttpRequest, HttpClient } from "@angular/common/http";
import { ProvidersService, FCCONFIG } from "fccore2";
import { FcinputComponent } from "../fcinput";
import { NzMessageService, UploadFile } from "ng-zorro-antd";
/**
 * fc-uploadä¸ä¼ 
 * ä¸ä¼ æ¯å°ä¿¡æ¯ï¼ç½é¡µãæå­ãå¾çãè§é¢ç­ï¼éè¿ç½é¡µæèä¸ä¼ å·¥å·åå¸å°è¿	ç¨æå¡å¨ä¸çè¿ç¨ã
 * å½éè¦ä¸ä¼ ä¸ä¸ªæä¸äºæä»¶æ¶ã
 * å½éè¦å±ç°ä¸ä¼ çè¿åº¦æ¶ã
 * å½éè¦ä½¿ç¨ææ½äº¤äºæ¶ã
 * äºä»¶ï¼
 * 1.æåäºä»¶ï¼success
 * 2.å¤±è´¥äºä»¶ï¼failure
 * 3.æ­£å¨ä¸ä¼ ï¼uploading
 */
@Component({
  selector: "fc-upload",
  template: `
  <nz-upload *ngIf="(fcListType==='text'||fcListType===undefined)&&!fcShowLabel"
  [nzAccept]="fcAccept" [nzLimit]="fcLimit" [nzSize]="fcFileSize"
  [nzFileType]="fcFileType" [nzAction]="_url" [nzListType]="fcListType"
   [nzData]="fcOption" [nzMultiple]="fcMultiple" [nzName]="'files'"
    [ngClass]="{'fc-readonly':_readonly===true}" [nzDisabled]="_dis||_disabled"
     [nzShowButton]="!_readonly||_readonly===undefined" [nzFileList]="_fileList"
      [nzBeforeUpload]="_beforeUpload">
        <button nz-button   *ngIf="!_readonly">
            <i class="icon iconfont fc-icon-uploading'"></i>
            ä¸ä¼ æä»¶
        </button>
  </nz-upload>
<button *ngIf="(fcListType==='text'||fcListType===undefined)&&!fcShowLabel"
 nz-button [nzType]="'primary'" [nzLoading]="uploading"
 (click)="_handleUpload()" [disabled]="_fileList.length == 0"
 style="margin-top: 10px;">{{ uploading ? 'ä¸ä¼ ä¸­' : 'å¼å§ä¸ä¼ ' }}</button>
<div class="clearfix" *ngIf="fcListType==='picture-card'&&!fcShowLabel">
    <nz-upload [nzAction]="_url" [nzListType]="_listType" [nzAccept]="fcAccept"
     [nzLimit]="fcLimit" [nzName]="'files'" [nzSize]="fcFileSize"
     [nzFileType]="fcFileType" [nzData]="fcOption" [(nzFileList)]="_fileList"
     [ngClass]="{'fc-readonly':_readonly===true}" [nzShowButton]="!_readonly"
      [nzDisabled]="_dis||_disabled" [nzPreview]="_handlePreview"
      [nzRemove]="_removeUpload" (nzChange)="_uploadChange($event)" [nzMultiple]="fcMultiple">
        <i class="anticon anticon-plus"  *ngIf="!_readonly"></i>
        <div class="ant-upload-text"  *ngIf="!_readonly">ä¸ä¼ </div>
    </nz-upload>
    <nz-modal [nzVisible]="_previewVisible" [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="_previewVisible=false">
        <ng-template #modalContent>
            <img [src]="_previewImage" [ngStyle]="{ 'width': '100%' }"/>
        </ng-template>
    </nz-modal>
</div>
<div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
    <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
    <div nz-col [nzSpan]="valueSpan">
      <nz-upload *ngIf="fcListType==='text'||fcListType===undefined"
       [nzAccept]="fcAccept"  [nzLimit]="fcLimit"
        [nzSize]="fcFileSize" [nzFileType]="fcFileType"
        [nzName]="'files'" [nzAction]="_url"
        [nzListType]="fcListType" [nzData]="fcOption"
        [nzMultiple]="fcMultiple" [ngClass]="{'fc-readonly':_readonly===true}"
        [nzDisabled]="_dis||_disabled"
         [nzShowButton]="!_readonly||_readonly===undefined"
          [nzFileList]="_fileList" [nzBeforeUpload]="_beforeUpload">
      <button nz-button  *ngIf="!_readonly">
          <i class="icon iconfont fc-icon-uploading"></i>
          éæ©æä»¶
      </button>
      </nz-upload>
      <button *ngIf="fcListType==='text'||fcListType===undefined"
       nz-button [nzType]="'primary'" [nzLoading]="uploading" (click)="_handleUpload()"
       [disabled]="_fileList.length == 0"
        style="margin-top: 10px;">{{ uploading ? 'ä¸ä¼ ä¸­' : 'å¼å§ä¸ä¼ ' }}</button>
      <div class="clearfix" *ngIf="fcListType==='picture-card'">
          <nz-upload [nzAction]="_url"  [nzName]="'files'" [nzAccept]="fcAccept"
           [nzLimit]="fcLimit"  [nzSize]="fcFileSize" [nzFileType]="fcFileType"
            [nzListType]="_listType" [nzData]="fcOption" [(nzFileList)]="_fileList"
             [ngClass]="{'fc-readonly':_readonly===true}" [nzShowButton]="!_readonly"
             [nzDisabled]="_dis||_disabled" [nzPreview]="_handlePreview"
             [nzRemove]="_removeUpload" (nzChange)="_uploadChange($event)"
             [nzMultiple]="fcMultiple">
              <i class="anticon anticon-plus"></i>
              <div class="ant-upload-text" *ngIf="!_readonly">ä¸ä¼ </div>
          </nz-upload>
          <nz-modal [nzVisible]="_previewVisible" [nzContent]="modalContent" [nzFooter]="null" (nzOnCancel)="_previewVisible=false">
              <ng-template #modalContent>
                <img [src]="_previewImage" [ngStyle]="{ 'width': '100%' }"/>
              </ng-template>
          </nz-modal>
      </div>
    </div>
</div>
<nz-upload [nzAction]="_url" [nzName]="'files'" [nzAccept]="fcAccept"
 [nzLimit]="fcLimit"  [nzSize]="fcFileSize" [nzFileType]="fcFileType"
  *ngIf="fcListType==='icon'&&fcShowLabel === 'N'"
  [nzData]="fcOption" [nzMultiple]="fcMultiple"
  [ngClass]="{'fc-readonly':_readonly===true}" [nzDisabled]="_dis||_disabled"
  [nzShowButton]="!_readonly||_readonly===undefined"
  [nzFileList]="_fileList" [nzBeforeUpload]="_beforeUpload">
      <button nz-button   *ngIf="!_readonly">
        <i class="anticon anticon-upload"></i><span>ä¸ä¼ æä»¶</span>
      </button>
</nz-upload>
    `,
  styles: [
    `
  .fc-readonly {
    pointer-events: none;
    }
  :host ::ng-deep .fc-readonly .ant-input-number-input-wrap{
    background-color: #ccc;
    }
  `
  ]
})
export class FcuploadComponent extends FcinputComponent {
  @Input()
  fcAccept: string;
  @Input()
  fcLimit: number = 0;
  @Input()
  fcFileSize: number = 0;
  @Input()
  fcFileType: string;
  /**ä¸ä¼ çå°å*/
  _url: string;
  /**ä¸ä¼ åè¡¨çåå»ºæ ·å¼,æ¯æä¸ç§åºæ¬æ ·å¼ text, picture å picture-card*/
  @Input()
  fcListType: string;
  _listType: string;
  /**ä¸ä¼ å°è¾¾ä¸ªæ°æ¶æé®æ¶å¤±*/
  @Input()
  fcNumber: number = 0;
  _previewImage = "";
  _previewVisible = false;
  /**æ¯å¦æ¾å¤§é¢è§å¾ç*/
  @Input()
  fcPreview: boolean;
  uploading = false;
  _fileList: UploadFile[];
  /**æ¯å¦æ¯æå¤é*/
  @Input()
  fcMultiple: boolean = true;
  @Input()
  fcDis: string;
  _dis: boolean;
  @Input()
  fcIcon: string;
  constructor(
    public provider: ProvidersService,
    private http: HttpClient,
    private msg: NzMessageService
  ) {
    super(provider, "fc-upload");
    this._url = this.daoService.getUrl(
      FCCONFIG.uploadurl + "SYSTEM/SYSRESLIB/upload",
      { PRODUCTID: FCCONFIG.pid }
    );
    if (this.fcListType === undefined) {
      this.fcListType = "text";
    }
    if (this.fcPreview === undefined) {
      this.fcPreview = true;
    }
  }
  _afterParentInit(): void {
    /** æµè¯ */
    if (this.fcDis === "Y") {
      this._dis = true;
    } else {
      this._dis = false;
    }
    if (this.fcOption === undefined) {
      throw new Error("è¯·éç½®åæ°ï¼FILETYPEï¼SOURCEAID,SOURCEID");
    }
    /** åå§åå·²ä¸ä¼ çæä»¶ */
    if (this.fcListType === "picture-card") {
      this._fileList = [];
      this.pushDestroy(
        this.appService
          .findWithQuery("SYSRESLIB", {
            WHERE:
              "{RESTYPE:{eq:'PIC'}, SOURCEID:{eq:'" +
              this.fcOption.SOURCEID +
              "'}, SOURCEAID:{eq:'" +
              this.fcOption.SOURCEAID +
              "'}}"
          })
          .subscribe(result => {
            if (result.CODE === "0") {
              result.DATA.forEach(item => {
                this._fileList.push({
                  uid: item.ID,
                  size: item.RESSIZE,
                  name: item.RESNAME,
                  type: item.RESTYPE,
                  url: item.RESPATH,
                  status: "done"
                });
              });
              this._listType = this.fcListType;
              this.event("loaded", this._fileList);
            }
          })
      );
    } else {
      this._fileList = [];
    }
    /**æ¯å¦ç¦ç¨*/
    if (this.fcDisabled === "Y") {
      this._disabled = true;
    } else {
      this._disabled = false;
    }
    /**æ¯å¦åªè®*/
    if (this.fcReadonly === "Y") {
      this._readonly = true;
    } else {
      this._readonly = false;
    }
  }
  /**
   * åæ­¢ä¸ä¼ 
   */
  _beforeUpload = (file: UploadFile): boolean => {
    this._fileList.push(file);
    return false;
  };
  /**
   * å¼å§ä¸ä¼ 
   */
  _handleUpload() {
    const formData = new FormData();
    this._fileList.forEach((file: any) => {
      formData.append(file.name, file);
    });
    Object.keys(this.fcOption).forEach(key => {
      formData.append(key, this.fcOption[key]);
    });
    formData.append("PRODUCTID", FCCONFIG.pid);

    this.uploading = true;
    /** You can use any AJAX library you like*/
    const req = new HttpRequest("POST", this._url, formData, {
      /** reportProgress: true*/
    });
    this.pushDestroy(
      this.daoService
        .upload(formData)
        // .pipe(filter(e => e instanceof HttpResponse))
        .subscribe(
          (result: any) => {
            this.uploading = false;
            if (result.CODE === "0") {
              this.msg.success("ä¸ä¼ æå.");
              this.event("success", result.DATA);
              /**ä¸ä¼ æååå¨å¾ä¸ä¼ ä½ç½®ä¸­æ¸ç©ºå·²ä¸ä¼ çæä»¶*/
              this._fileList = [];
            } else {
              this.msg.error(result.MSG);
              this.event("failure", "ä¸ä¼ å¤±è´¥");
            }
          },
          err => {
            this.uploading = false;
            this.msg.error("ä¸ä¼ å¤±è´¥.");
            this.event("failure", "ä¸ä¼ å¤±è´¥");
          }
        )
    );
  }
  /**
   * ä¸ä¼ å¾çæä»¶ç¶ææ¹åçåè°äºä»¶æåº
   * @param event
   */
  _uploadChange(event: any) {
    if (event.file.error) {
      this.event("error", event.file.error);
    }
    if (event.file.status === "start") {
      this.event("start", event.file);
    }
    if (event.file.status === "progress") {
      this.event("progress", event.file.percent);
    }
    if (event.file.status === "success" || event.file.status === "done") {
      this.event("success", event.file);
    }
  }
  /**
   * å¾çç¹å»é¢è§ï¼fcPreviewä¸ºtrueæ¶å¯ä»¥é¢è§ï¼fcPreviewä¸ºfalseä¸è½é¢è§ä¸æåºéä¸­å¾çäºä»¶
   */
  _handlePreview = (selectedFile: UploadFile) => {
    this._previewImage = selectedFile.url || selectedFile.thumbUrl;
    if (this.fcPreview) {
      this._previewVisible = true;
    } else if (!this.fcPreview) {
      this._previewVisible = false;
      this.event("selectedPic", selectedFile);
    }
  };
  /**
   * å é¤
   */
  _removeUpload = (removefile: UploadFile) => {
    this._fileList = this._fileList.filter(file => file.uid !== removefile.uid);
    this.pushDestroy(
      this.appService
        .deleteObject("SYSRESLIB", removefile.uid)
        .subscribe(result => {
          if (result.CODE === "0") {
            this.event("removeFile", this._fileList);
          }
        })
    );
  };
}
